import './offerHeader.css';

import {ReactComponent as JDFLogo} from '../../../assets/svg/jdf_logo_new.svg';

import React from 'react';

const NonMfaHeader = (props) => {
  const navigate = (location) => {
    props.setView(location);
  };

  return (
    <>
      <header id="CustomHeader">
        <div className="jdf-logo">
          <JDFLogo />
        </div>
      </header>
    </>
  );
};

export default NonMfaHeader;
